/**
 * Custom element: imperative DOM, no React inside the card.
 * Dispatches `mob-product-navigate` with detail `{ id }` for PDP (handled by React shell).
 */
const EVENT_NAV = 'mob-product-navigate';

export class MobProductCard extends HTMLElement {
    constructor() {
        super();
        this._product = null;
        this._slideIndex = 0;
    }

    set product(value) {
        this._product = value;
        this._slideIndex = 0;
        this._render();
    }

    get product() {
        return this._product;
    }

    connectedCallback() {
        if (this._product) this._render();
    }

    _render() {
        const p = this._product;
        if (!p || !p.urls?.length) {
            this.textContent = '';
            return;
        }

        this.replaceChildren();
        this.className = 'mob-wc-card';

        const viewport = document.createElement('div');
        viewport.className = 'mob-wc-card__viewport';
        viewport.setAttribute('role', 'button');
        viewport.setAttribute('aria-label', 'Tap to cycle images');

        const img = document.createElement('img');
        img.className = 'mob-wc-card__img';
        img.alt = '';
        img.draggable = false;

        const applySlide = () => {
            img.src = p.urls[this._slideIndex];
        };
        applySlide();

        viewport.addEventListener('click', (e) => {
            e.preventDefault();
            if (p.urls.length > 1) {
                this._slideIndex = (this._slideIndex + 1) % p.urls.length;
                applySlide();
            }
        });

        viewport.appendChild(img);

        const meta = document.createElement('div');
        meta.className = 'mob-wc-card__meta';

        const brand = document.createElement('div');
        brand.className = 'mob-wc-card__brand';
        brand.textContent = p.brand ?? '—';

        const title = document.createElement('div');
        title.className = 'mob-wc-card__title';
        title.textContent = p.title || '';

        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'mob-wc-card__view-btn';
        btn.textContent = `View product · Rs. ${p.price ?? '—'}`;
        btn.addEventListener('click', () => {
            window.dispatchEvent(
                new CustomEvent(EVENT_NAV, {
                    detail: { id: p.id },
                    bubbles: true,
                })
            );
        });

        meta.append(brand, title, btn);
        this.append(viewport, meta);
    }
}

if (!customElements.get('mob-product-card')) {
    customElements.define('mob-product-card', MobProductCard);
}
